import { render, staticRenderFns } from "./GroupedSlotsListItem.vue?vue&type=template&id=131bd3ba&"
import script from "./GroupedSlotsListItem.vue?vue&type=script&lang=js&"
export * from "./GroupedSlotsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports